export default "__VITE_ASSET__DTnk5Xcx__"